import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const SalesFunnelTopHeader = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const selectedOption = getFilterTextFieldValue(filterData, 'sort', 'sales_funnel_sort');
	const dispatch = useDispatch();

	const options = [
		{ label: 'Group By Brand Name', value: 'brandName' },
		{ label: 'Group By Account Manager', value: 'keyAccountManager' },
		{ label: 'Group By Department (Market)', value: 'productGroupName' }
	];

	const handleOptionClick = (item) => {
		let data = {
			name: 'sort',
			type: 'text',
			key: item.value,
			value: item.label,
			identifier: 'sales_funnel_sort'
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<>
			{/* <div className="d-flex align-items-center">
				<p className="regular-14 gray_dark_02 mr-3">Dashboard</p>
				{crmStore?.isShowSalesFunnelSummary && (
					<img
						className="cursor-pointer"
						src="/icons/toggle-on.svg"
						alt="toggle"
						onClick={() => {
							dispatch(toggleCRMSalesFunnelSummary(false));
						}}
					/>
				)}
				{!crmStore?.isShowSalesFunnelSummary && (
					<img
						className="cursor-pointer"
						src="/icons/toggle-off.svg"
						alt="toggle"
						onClick={() => {
							dispatch(toggleCRMSalesFunnelSummary(true));
						}}
					/>
				)}
			</div> */}
			<div className="single-filter ml-3">
				<div className="dropdown">
					<button
						className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
						type="button"
						data-toggle="dropdown"
						aria-expanded="false"
					>
						{selectedOption?.value || 'Select Group By'}
					</button>
					<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
						{options?.map((item) => (
							<li
								key={`sales_funnel_dashboard_${item.value}`}
								onClick={() => {
									handleOptionClick(item);
								}}
							>
								<span>{item.label}</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	);
};

export default SalesFunnelTopHeader;
